export default __webpack_public_path__ + "static/media/settings-on.27f1cf04.svg";